"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var colour_1 = require("../theme/colour");
var size_1 = require("../theme/size");
function ArrowIcon(_a) {
    var direction = _a.direction, _b = _a.colour, colour = _b === void 0 ? colour_1.colours.purple[60] : _b, _c = _a.size, size = _c === void 0 ? size_1.IconSize.NORMAL : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", transform: getTransform(direction) }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M8.81477 0.670677C9.17275 1.11818 9.17275 1.84372 8.81477 2.29122L3.96295 8.35632H18.2499C18.7562 8.35632 19.1666 8.86935 19.1666 9.50221C19.1666 10.1351 18.7562 10.6481 18.2499 10.6481H3.96295L8.81477 16.7132C9.17275 17.1607 9.17275 17.8862 8.81477 18.3337C8.45679 18.7812 7.87638 18.7812 7.5184 18.3337L1.10174 10.3125C0.743757 9.86498 0.743757 9.13944 1.10174 8.69194L7.5184 0.670677C7.87638 0.223178 8.45679 0.223178 8.81477 0.670677Z", fill: colour }) })));
}
exports.ArrowIcon = ArrowIcon;
function getTransform(direction) {
    switch (direction) {
        case size_1.IconDirection.LEFT:
            return 'rotate(0)';
        case size_1.IconDirection.UP:
            return 'rotate(90)';
        case size_1.IconDirection.RIGHT:
            return 'rotate(180)';
        case size_1.IconDirection.DOWN:
            return 'rotate(-90)';
    }
}
